import React from 'react'

export default function Result() {
  return (
    <div>
        restult
    </div>
  )
}